// TanStack Query hook for fetching agent tools and MCPs.
// TODO: when toolsApi is wired to shared/api, update the queryFn here accordingly.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchAgentTools } from '../api/toolsApi';
import type { AgentToolsView } from './toolTypes';

export const agentToolsKeys = {
  byAgent: (agentId: string) => ['agent', 'tools', agentId] as const,
};

export function useAgentToolsQuery(agentId: string): UseQueryResult<AgentToolsView> {
  return useQuery<AgentToolsView>({
    queryKey: agentToolsKeys.byAgent(agentId),
    queryFn: () => fetchAgentTools(agentId),
    enabled: agentId.length > 0,
  });
}
